export const rows = [
  { sin: 'Horas planificando desde cero cada semana', con: '5 minutos. Todo listo.' },
  { sin: 'Sesiones improvisadas sin progresión real.', con: '+240 sesiones detalladas por nivel' },
  { sin: 'Grupos sin sistema claro', con: 'Estructura clara para cada nivel.' },
  { sin: 'Siempre los mismos ejercicios', con: '100+ listas de variaciones' },
  { sin: 'Miedo a que una alumna se lesione', con: 'Protocolo de seguridad incluido' },
  { sin: 'Terminar cada clase agotada mentalmente', con: 'Llegas con todo resuelto' },
  { sin: 'Sin poder justificar un aumento de precio', con: 'Sistema documentado y profesional' },
  { sin: 'Dudas en cada corrección', con: 'Cues y frases exactas' }
];
